module.exports = __webpack_public_path__ + "static/media/you-might-like-banner.a7c1ab0c.png";